<template>
  <div
    v-if="mode === 'hover'"
    class="tooltip-container"
    @mouseenter="showTooltip($event)"
    @mouseleave="delayedHideTooltip"
  >
    <slot></slot>
    <portal to="flagTooltipPortal">
      <template v-if="isVisible || isForceVisible">
        <div
          class="tooltip"
          :class="{ 'hide-tooltip': tooltipVisibility, 'no-padding': noPadding }"
          @mouseenter="showTooltipByTooltip"
          @mouseleave="hideTooltip"
        >
          <slot name="content"></slot>
          <div v-if="$slots.actions" class="tooltip-actions">
            <slot name="actions"></slot>
          </div>
        </div>
      </template>
    </portal>
  </div>
  <div
    v-else-if="mode === 'click'"
    class="tooltip-container"
    @click="showTooltip"
    v-click-outside="hideTooltip"
  >
    <slot></slot>
    <template v-if="isVisible || isForceVisible">
      <div class="tooltip" :class="direction">
        <slot name="content"></slot>
      </div>
    </template>
  </div>
</template>

<script>
import {
  computePosition,
  flip,
} from '@floating-ui/dom/dist/floating-ui.dom.esm.js'

export default {
  name: 'BaseTooltip',
  props: {
    direction: {
      type: String,
      default: 'bottom',
    },
    mode: {
      type: String,
      default: 'hover',
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: false,
      isForceVisible: false,
      message: 'This is a tooltip!',
      tooltipVisibility: true,
    }
  },
  methods: {
    showTooltip(e) {
      let flagElement
      let tooltipPortal
      this.isVisible = true
      setTimeout(() => {
        flagElement = e.target
        tooltipPortal = document.getElementById('tooltip-portal').firstChild
        computePosition(flagElement, tooltipPortal, {
          placement: 'top',
          middleware: [flip()],
        }).then(({ x, y }) => {
          Object.assign(tooltipPortal.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
        this.tooltipVisibility = false
      }, 50)
    },
    showTooltipByTooltip() {
      this.isForceVisible = true
    },
    hideTooltip() {
      this.isVisible = false
      this.isForceVisible = false
      this.tooltipVisibility = true
    },
    delayedHideTooltip() {
      setTimeout(() => {
        if (!this.isForceVisible) {
          this.hideTooltip()
        }
      }, 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  padding: 16px;
  background-color: varFigma(neutral-100-white);
  border-radius: 8px;
  white-space: nowrap;
  z-index: 42;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 205px !important;
  &.bottom {
    top: calc(100% + 5px);
    transform: translateX(-50%);
  }

  &.top {
    bottom: calc(100% + 5px);
    transform: translateX(-50%);
  }

  &.right {
    top: 0;
    left: calc(100% + 5px);
  }
}
.tooltip.no-padding {
  padding: 0 !important;
}
.hide-tooltip {
  visibility: hidden;
}
.tooltip-actions {
  padding: 16px 20px;
  display: flex;
  justify-content: flex-end;
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: varFigma(neutral-100-white);
}
</style>
